import React from "react"
import { rodgPath, hasParks } from "./helpers/storage"

const RideOrDiesLink = () => (
  <a href={rodgPath()} className="rodg-emphasis">
    RIDE OR DIES
  </a>
)

const EmptyState = ({ context }) => (
  <div className="rodg-refresh-banner">
    {hasParks() ? (
      <>
        No <RideOrDiesLink /> selected - go to your <a href={rodgPath("list")}>list</a> to select.
      </>
    ) : (
      <>
        Pick your <RideOrDiesLink /> to include them on the {context === "map" ? "map" : "wheel"}.
      </>
    )}
  </div>
)

export default EmptyState
